import axios from 'axios';
import type { DateTime } from 'luxon';

export default class BannerGroupsService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/cms/banners/groups`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/banners/groups/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post(`admin/cms/banners/groups`, model)).data as Resource<FormModel>;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put(`admin/cms/banners/groups/${id}`, model)).data as Resource<FormModel>;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/banners/groups/${id}`)).data as Statement;
    }

    public static async getAutocompleteList(search: string, limit: number = 10, internalOnly = false)
    {
        return (await axios.get<ListItemModel[]>(`admin/cms/banners/groups/autocomplete`, {
            params: {
                search: search,
                limit: limit,
                internalOnly: internalOnly
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<ListItemModel[]>(`admin/cms/banners/groups/autocomplete/${id}`)).data;
    }
}

export interface ListItemModel
{
    id: number;
    name: string;
    type: string;
    dateCreatedUtc?: DateTime;
    dateModifiedUtc?: DateTime;
}

export interface FormModel
{
    id: number;
    name: string;
    type: string;
    contentJson: string;
}

export interface FilterModel
{
    name: string;
    type: BannerGroupTypeEnum;
}

export interface ListItemOptionsModel
{
    id: number;
    name: string;
}
